<template>
  <DialogCard>
    <template #title>
      Contact
    </template>
    <template #text>
      openVOXEL Project<br>
      Email: <a
        href="mailto:openvoxelorg@gmail.com"
        target="_blank"
        rel="noopener noreferrer"
      >openvoxelorg@gmail.com</a>
    </template>
  </DialogCard>
</template>

<script>
import DialogCard from '@/layout/BottomDrawer/DialogCard.vue';

export default {
  name: 'OpenvoxelContactDialog',
  components: {
    DialogCard,
  },
};
</script>
